'use client';

import { SettingsSection } from '@/core/components/settings/settings-section';

interface AccountSecuritySectionProps {
  sectionId: string;
  dict: {
    title: string;
    description: string;
    loginInfo: string;
  };
}

export function AccountSecuritySection({
  sectionId,
  dict,
}: AccountSecuritySectionProps) {
  return (
    <SettingsSection
      id={sectionId}
      title={dict.title}
      info={dict.description}
      footer={dict.loginInfo}
      grouped
    />
  );
}
